import { render, staticRenderFns } from "./rolesPermissions.vue?vue&type=template&id=86cbac02&scoped=true"
import script from "./rolesPermissions.vue?vue&type=script&lang=js"
export * from "./rolesPermissions.vue?vue&type=script&lang=js"
import style0 from "./rolesPermissions.vue?vue&type=style&index=0&id=86cbac02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86cbac02",
  null
  
)

export default component.exports